import { locationEnums, resultListClickedItemKey } from '../appSettings';
import { syncStateToQueryParams } from './urlStateUtils';

// Standardised debounce function - same as lodash's
// https://davidwalsh.name/javascript-debounce-function
export const debounce = (func, wait, immediate) => {
	let timeout;
	return () => {
		const context = this
    /* eslint-disable no-undef */
    const args = arguments;
		const later = () => {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export const getNextResultCount = (currentCount, increment, totalCount) => {
	const nextCount = currentCount + increment
	if (nextCount <= totalCount) {
    // add 6 more every load as long as there are enough hotels
		
    return nextCount > currentCount ? nextCount : nextCount + increment;
  }
  // otherwise set the length as the total number of hotels
  return totalCount
}

// Never pass in "ANYWHERE" as a location when querying Origo
export const verifyLocation = (selectedLocation) => {
	return selectedLocation !== locationEnums.ANYWHERE ? selectedLocation : null;
}

const getMatchingSelectedClassifications = ({
	taggedClassifications,
	selectedClassifications,
	classifications,
}) => {
	let allChildren = {}
	classifications.forEach(classification => {
		allChildren = {
			...allChildren,
			...classification.children,
		}
	});

	// Get the keys that exists both in the list of selected classifications and the list of the hotel's classifications
	const matchingKeys = taggedClassifications?.filter(key => selectedClassifications.includes(key));
	// Then return the displayNames for all the matching classifications
	return matchingKeys?.map(matchingKey => allChildren[matchingKey]?.displayName);
}

export const getMatchingClassificationBadges = (itemClassifications, classifications, primaryClassifications, secondaryClassifications) => {
	const availableClassifications = primaryClassifications ? primaryClassifications.map(classificationKey => {
		return classifications[classificationKey];
	}) : null

	// return getMatchingBadges(itemClassifications, selectedSecondaryClassifications, availableClassifications)
	if (secondaryClassifications) {
		return getMatchingSelectedClassifications({
			taggedClassifications: itemClassifications,
			selectedClassifications: secondaryClassifications,
			classifications: availableClassifications,
		});
	}
	return null;
}

// Never pass in "ANYWHERE" as a location when querying Origo
export const verifyLocations = (selectedLocations) => {
	if (!selectedLocations) return null

	const verifiedLocations = selectedLocations.includes(locationEnums.ANYWHERE) ? selectedLocations.filter(location => location !== locationEnums.ANYWHERE) : selectedLocations;
	return verifiedLocations;
}

export const getExcursionUrl = (siteId, masterId) => {
  const queryParams = `masterId=${masterId}`;

  switch (parseInt(siteId, 10)) {
    case 1:
      return `/utflykter/visa-utflykt?${queryParams}`;
    case 3:
      return `/utflukter/vis-utflukt?${queryParams}`;
    case 11:
      return `/udflugter/vis-udflugt?${queryParams}`;
    case 15:
      return `/retket/nayta-retki?${queryParams}`;
    default:
      return `/utflykter/visa-utflykt?${queryParams}`;
  }
};

/* eslint-disable no-unused-vars */
let vfScrollAttempts = 0
export const attemptScrollToCard = (cardId) => {
	const card = document.getElementById(cardId);
	if (card) {
		sessionStorage.removeItem(resultListClickedItemKey);
		syncStateToQueryParams({ linkTriggered: null });
		setTimeout(() => {
			// timeout to let things get rendered. The scrollIntoView happened before
			// everything above was rendered, so the viewport shifted to the wrong position
			vfScrollAttempts = 0;
			card.scrollIntoView();
		}, 500)
	} else if (cardId && vfScrollAttempts < 5) {
		setTimeout(() => {
			vfScrollAttempts += 1;
			attemptScrollToCard(cardId);
		}, 200)
	} else {
		vfScrollAttempts = 0;
		sessionStorage.removeItem(resultListClickedItemKey);
		return null;
	}
}


export const createAnchor = (name) => {
	return name.replaceAll(' ', '_');
}

export const handleAnchor = (anchorName) => {
	syncStateToQueryParams({ linkTriggered: 1 })
	sessionStorage.setItem(resultListClickedItemKey, createAnchor(anchorName))
}

export const getSubTitle = (excursion) => {
	if (excursion.country) {
		if (excursion.area) {
			if (excursion.area !== excursion.country) {
				return `${excursion.area}, ${excursion.country}`;
			}
		}
		return `${excursion.country}`;
	}
	if (excursion.area) {
		return `${excursion.area}`;
	}
	return '';
};

export const getRelativeImageUrlFromStatic = (staticUrl) => {
	if (staticUrl) {
		try {
			return new URL(staticUrl).pathname;
		} catch (err) {
			console.error('Failed to convert static url to relative', err);
			return null;
		}
	}
	return null;
}
